import { render, staticRenderFns } from "./InquiryComplaints.vue?vue&type=template&id=baa949c8&"
import script from "./InquiryComplaints.vue?vue&type=script&lang=js&"
export * from "./InquiryComplaints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports